/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_PUBLIC } from '../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Module]
-------------------------------------------------------------------*/
import { decode } from "html-entities";
import ReactPlayer from "react-player"
import LinesEllipsis from 'react-lines-ellipsis'
/*------------------------------------------------------------------
[End React Module]
-------------------------------------------------------------------*/

const Screen = ({loading, error}) => {

    const [data, set_data] = useState(null);

    const [pagination_active, set_pagination_active] = useState(1);

    const _read = (pages) => {

        let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (12 * pages) - 12 : 0
        
        }
        
        loading(true);

        API_GET_PUBLIC(`client/video__________?limit=12&offset=${offsetSync}`)
        .then((response) => {
            if(response.data.result === 'success'){
                loading(false)
                set_data(response.data.data)
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

    }
    
    useEffect(() => {
        
		_read()

    }, [])

	return (
		<>
            <Helmet>

                <meta name="description" content={'Video'}/>
                <title>{'Video'}</title>

            </Helmet>

            <div className="_container">
                <div className="_lily_pad_h_d __section_pages_title">
                    <h1>Video</h1>
                </div>
            </div>
            <div className="_container">
                <div className="_row_sync" style={{alignItems: 'center'}}>
                    {
                        data ?
                            data.video.map((item, index) => {
                                return (
                                    <div className="_column_sync">
                                        <div className='__video_container'>
                                            <ReactPlayer
                                                className='__video_player'
                                                url={decode(item.video)}
                                                width='100%'
                                                height='100%'
                                            />
                                        </div>
                                        <LinesEllipsis
                                            style={{marginTop: 6}}
                                            text={decode(item.title)}
                                            maxLine='2'
                                            ellipsis='...'
                                            trimRight
                                            basedOn='letters'
                                        />
                                    </div>
                                )
                            })
                        :
                            <>
                                <div className="_column_sync">
                                    <div style={{height: 200, backgroundColor: '#eee'}}/>
                                </div>
                                <div className="_column_sync">
                                    <div style={{height: 200, backgroundColor: '#eee'}}/>
                                </div>
                                <div className="_column_sync">
                                    <div style={{height: 200, backgroundColor: '#eee'}}/>
                                </div>
                                <div className="_column_sync">
                                    <div style={{height: 200, backgroundColor: '#eee'}}/>
                                </div>
                                <div className="_column_sync">
                                    <div style={{height: 200, backgroundColor: '#eee'}}/>
                                </div>
                                <div className="_column_sync">
                                    <div style={{height: 200, backgroundColor: '#eee'}}/>
                                </div>
                                <div className="_column_sync">
                                    <div style={{height: 200, backgroundColor: '#eee'}}/>
                                </div>
                                <div className="_column_sync">
                                    <div style={{height: 200, backgroundColor: '#eee'}}/>
                                </div>
                                <div className="_column_sync">
                                    <div style={{height: 200, backgroundColor: '#eee'}}/>
                                </div>
                                <div className="_column_sync">
                                    <div style={{height: 200, backgroundColor: '#eee'}}/>
                                </div>
                                <div className="_column_sync">
                                    <div style={{height: 200, backgroundColor: '#eee'}}/>
                                </div>
                                <div className="_column_sync">
                                    <div style={{height: 200, backgroundColor: '#eee'}}/>
                                </div>
                            </>
                    }
                </div>
            </div>
            <div className="_container">
                <div className="_lily_pad_h_d">
                    <div className="__pagination">
                        {
                            data&&data.pages.map((item, index) => {
                                if(data.pages.length > 1){
                                    return (

                                        <div 
                                            key={index} 
                                            className="__item"
                                            style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                            onClick={() => {
                                                _read(index + 1);
                                                set_pagination_active(index + 1)
                                            }}
                                        >
                                            <div className="_position_middle">
                                                {item}
                                            </div>
                                        </div>
                                        
                                    )
                                }
                            })
                        }
                    </div>
                </div>
            </div>
		</>
	);
}

export default Screen;